// extracted by mini-css-extract-plugin
export var content = "InsightsCarouselModule-module--content--fc923";
export var contentContainer = "InsightsCarouselModule-module--contentContainer--7a18b";